import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  IconButton,
  Sheet,
  SheetBody,
  SheetContent,
  Typography,
} from "@suraasa/placebo-ui"
import { useMediaQuery } from "@uidotdev/usehooks"
import CpatTourOnboardingMainImage from "assets/Cpat/Tour/main.webp"
import { Xmark } from "iconoir-react"

const GetStarted = ({
  open,
  handleContinue,
  handleClose,
}: {
  open: boolean
  handleContinue: () => void
  handleClose?: () => void
}) => {
  const isSmDown = useMediaQuery("only screen and (max-width : 599px)")
  const Content = (
    <div className="relative">
      {handleClose && (
        <DialogClose autoFocus={false} className="absolute right-2 top-2">
          <IconButton color="black">
            <Xmark />
          </IconButton>
        </DialogClose>
      )}

      <div className="flex flex-col">
        <div className="h-[213px] w-full sm:h-[274px]">
          <img
            src={CpatTourOnboardingMainImage}
            alt="main-img"
            className="size-full rounded-t-2xl object-cover"
          />
        </div>

        <div className="p-3">
          <Typography variant="title2" className="mb-1.5 text-onSurface-900">
            What you need to know
          </Typography>

          <Typography variant="largeBody" className="mb-5 text-onSurface-500">
            Take a quick tour to understand how the assessment works before you
            get started.
          </Typography>

          <div className="flex flex-row items-center justify-between">
            {handleClose && (
              <Button
                className="text-onSurface-700"
                color={"black"}
                variant={"text"}
                onClick={handleClose}
                autoFocus={false}
              >
                Skip
              </Button>
            )}
            <Button
              className="ml-auto flex"
              color="black"
              onClick={handleContinue}
              autoFocus
            >
              Take the Tour
            </Button>
          </div>
        </div>
      </div>
    </div>
  )

  if (isSmDown) {
    return (
      <Sheet open={open}>
        <SheetContent height={78} className="!p-0">
          <SheetBody className="!p-0">{Content}</SheetBody>
        </SheetContent>
      </Sheet>
    )
  }
  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="rounded-2xl">{Content}</DialogContent>
    </Dialog>
  )
}

export default GetStarted
